import styled, {css} from "styled-components"

import {H3Css as H3UiCss} from "@irati/ui/src/Headings"

export const H3Css = css`
  ${H3UiCss}
  font-size: 30px;
  line-height: 35px;
`

export default styled.h3`${H3Css}`
